import { RegionData } from '@/editor/data/region/Region';
import { RoomData } from '@/editor/data/room/Room';
import RegionEntity from '@/editor/entities/regionEntity';
import { globalStores } from '@/editor/stores';

export class RegionManager {
  private _list: RegionEntity[] = [];

  constructor() {}

  getEntityById(id: string) {
    return this._list.find((entity) => entity.id === id);
  }

  get entities() {
    return this._list;
  }

  private removeRegionEntityByIndex(index: number) {
    const regionEntity = this._list[index];
    if (regionEntity) {
      regionEntity.dispose();
      this._list.splice(index, 1);
    }
  }

  private addRegionEntity(regionEntity: RegionEntity) {
    this._list.push(regionEntity);
  }

  update(roomDatas: RoomData[]) {
    let regionDatas: RegionData[] = [];
    for (const roomData of roomDatas) {
      const roomRegionDatas = globalStores.regionStore.getRoomRegions(roomData.id);
      if (roomRegionDatas.length > 1) {
        regionDatas = regionDatas.concat(globalStores.regionStore.getRoomRegions(roomData.id));
      }
    }

    this.updateRegionEntities(regionDatas);
  }

  forceUpdate() {
    this._list.forEach((entity) => {
      const region = globalStores.regionStore.getRegionData(entity.id);
      if (region) entity.update({ ...region, forceUpdate: true });
    });
  }

  updateRoomRegions(id: string) {
    const regionDatas = globalStores.regionStore.getRoomRegions(id);

    for (const regionData of regionDatas) {
      this.updateEntity(regionData.id);
    }
  }

  private updateRegionEntities(regionDatas: RegionData[]) {
    // 要保留的隔墙
    const prevserveRegionEntities = regionDatas
      .map((regionData) => this.getEntityById(regionData.id))
      .filter((entity) => !!entity);
    // 删除旧数据
    for (let i = this._list.length - 1; i > -1; i--) {
      if (!prevserveRegionEntities.includes(this._list[i])) {
        this.removeRegionEntityByIndex(i);
      }
    }

    for (let i = 0; i < regionDatas.length; i++) {
      const regionData = regionDatas[i];

      const entity = this.getEntityById(regionData.id);
      if (!entity) {
        // 墙体数据不存在，创建新的墙体
        const regionEntity = new RegionEntity(regionData);
        this.addRegionEntity(regionEntity);
      } else {
        entity.update(regionData);
      }
    }
  }

  updateEntity(id: string) {
    const regionData = globalStores.regionStore.getRegionData(id);
    if (!regionData) return;

    const entity = this.getEntityById(id);
    if (entity) {
      entity.update(regionData);
    }
  }
}
